// Meetings module — shared constants + helpers (mirrors backend meetings.py)
import { istDay } from './format';

export const MEETING_STATUS_COLORS = {
  Scheduled: 'bg-blue-50 text-blue-700 border-blue-200',
  Rescheduled: 'bg-orange-50 text-orange-700 border-orange-200',
  Completed: 'bg-emerald-50 text-emerald-700 border-emerald-200',
  'No-Show': 'bg-red-50 text-red-700 border-red-200',
  Cancelled: 'bg-slate-100 text-slate-500 border-slate-200',
};

export const MEETING_STATUS_DOT = {
  Scheduled: 'bg-blue-500',
  Rescheduled: 'bg-orange-500',
  Completed: 'bg-emerald-500',
  'No-Show': 'bg-red-500',
  Cancelled: 'bg-slate-400',
};

export const OUTCOME_COLORS = {
  'Deal Closed': 'bg-emerald-50 text-emerald-700 border-emerald-200',
  'Offer Made': 'bg-violet-50 text-violet-700 border-violet-200',
  'Follow-Up Needed': 'bg-amber-50 text-amber-800 border-amber-200',
  'Callback Scheduled': 'bg-sky-50 text-sky-700 border-sky-200',
  'Not Interested': 'bg-red-50 text-red-700 border-red-200',
  Disqualified: 'bg-red-50 text-red-700 border-red-200',
};

// Solid calendar block styles (Scheduled-blue, Completed-green, No-Show-red,
// Rescheduled-orange, Cancelled-gray) per spec
export const CAL_BLOCK_COLORS = {
  Scheduled: 'bg-blue-500/90 border-blue-600 text-white',
  Rescheduled: 'bg-orange-500/90 border-orange-600 text-white',
  Completed: 'bg-emerald-500/90 border-emerald-600 text-white',
  'No-Show': 'bg-red-500/90 border-red-600 text-white',
  Cancelled: 'bg-slate-300 border-slate-400 text-slate-600',
  google: 'bg-slate-200/90 border-slate-300 text-slate-500',
};

export const fmtMeetingDate = (iso) => (iso ? istDay(iso).format('ddd, DD MMM YYYY') : '—');
export const fmtMeetingTime = (iso) => (iso ? istDay(iso).format('h:mm A') : '—');
export const fmtMeetingRange = (m) =>
  m?.start_at ? `${fmtMeetingTime(m.start_at)} – ${fmtMeetingTime(m.end_at)} IST` : '—';

// datetime-local input value (IST wall clock) from a stored IST-offset ISO string
export const toLocalDT = (iso) => (iso ? istDay(iso).format('YYYY-MM-DDTHH:mm') : '');

export const addMinutesLocal = (localDT, minutes) => {
  if (!localDT) return '';
  const d = new Date(localDT);
  d.setMinutes(d.getMinutes() + minutes);
  const pad = (n) => String(n).padStart(2, '0');
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}`;
};

export const conflictDetail = (err) => {
  const detail = err?.response?.data?.detail;
  if (detail && typeof detail === 'object' && detail.conflicts) return detail;
  return null;
};

export const errMessage = (err, fallback) => {
  const detail = err?.response?.data?.detail;
  if (typeof detail === 'string') return detail;
  if (detail?.message) return detail.message;
  return fallback;
};
